import React, { useState } from "react";
import "./styles.less";
import { Header } from "../../components/Header";
import { Footer } from "../../components/FooterV2";
import { ManufacturingBanner } from "./components/ManufacturingBanner";
import { ManufacturingMarquee } from "./components/ManufacturingMarquee";

import { FinanceChart } from "./components/ManufacturingChart";
import { ManufacturingQuestion } from "./components/ManufacturingQuestion";
import { ManufacturingAdvantage } from "./components/ManufacturingAdvantage";

import { HomeTryOn } from "../../blocks/home-try-on";
import { SolutionProduct } from "../../components/SolutionProduct";

export const Finance = (props) => {
  return (
    <div className="manufacturing">
      <Header mode="light" special />
      <ManufacturingBanner />
      <ManufacturingMarquee />
      <ManufacturingQuestion />
      <FinanceChart />
      <ManufacturingAdvantage />
      <SolutionProduct />
      <HomeTryOn hasBg />
      <Footer />
    </div>
  );
};
